// extracted by mini-css-extract-plugin
export default {"title":"Invitation_title__4-X70","content":"Invitation_content__r0e5e","form":"Invitation_form__Vnh8w","helpIcon":"Invitation_helpIcon__D2ZOZ","phone":"Invitation_phone__0KsMU"};